import React from 'react';
import MainContainer from '../mainContainer';
import Study from './study';

class WireSequence extends React.Component {
    render() {
        return (
            <MainContainer>
                <Study />
            </MainContainer>
        );
    }
}

export default WireSequence;
